import { render, staticRenderFns } from "./DialogDetailSupervision.vue?vue&type=template&id=b56a3672"
import script from "./DialogDetailSupervision.vue?vue&type=script&lang=js"
export * from "./DialogDetailSupervision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports